import {useQuery} from '@tanstack/react-query';
import {request} from './index.js';
import API_URLS from './urls.ts';
import {DURATION_MS} from './util.js';

const getIMSUserStatus = () =>
  request
    .get(`${API_URLS.ims}/users/me/status`)
    .then(response => response.data);

export const useGetIMSUserStatus = (queryOptions = {}) =>
  useQuery({
    queryKey: ['ims-me-status'],
    queryFn: getIMSUserStatus,
    staleTime: DURATION_MS.HOUR,
    ...queryOptions,
  });
